var H = Object.defineProperty, $ = Object.defineProperties;
var D = Object.getOwnPropertyDescriptors;
var N = Object.getOwnPropertySymbols;
var A = Object.prototype.hasOwnProperty, O = Object.prototype.propertyIsEnumerable;
var v = (e, a, t) => a in e ? H(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t, m = (e, a) => {
  for (var t in a || (a = {}))
    A.call(a, t) && v(e, t, a[t]);
  if (N)
    for (var t of N(a))
      O.call(a, t) && v(e, t, a[t]);
  return e;
}, C = (e, a) => $(e, D(a));
import { $emit as b } from "../utils/gogocodeTransfer.js";
import { ElTableColumn as V, ElTable as j } from "element-plus";
import { resolveComponent as T, openBlock as d, createBlock as M, mergeProps as f, withCtx as p, renderSlot as W, normalizeProps as _, guardReactiveProps as E, createElementBlock as g, normalizeClass as X, createVNode as w, createSlots as q, Fragment as k, renderList as Z, createTextVNode as L, toDisplayString as F, createElementVNode as x, createCommentVNode as S } from "vue";
import { _ as B } from "../_plugin-vue_export-helper-dad06003.js";
import G from "../pagination/index.js";
import I from "../loading/index.js";
const J = {
  name: "rTableColumn",
  components: {
    TableColumn: V
  },
  props: {
    align: {
      type: String,
      default: "right"
    },
    prop: {
      type: String
    },
    data: {
      type: Array,
      default: () => []
    },
    /**
     * 提供文案过长时支持hover显示气泡
     */
    showOverflowTooltip: {
      type: Boolean,
      default: !0
    },
    width: {
      type: [String, Number],
      default: "computed"
    },
    label: {
      type: String,
      default: ""
    },
    minWidth: {
      type: [Number, String]
    },
    maxWidth: {
      type: Number
    },
    /**
     * 列与列之间的内间距, 只支持数字，单位为像素
     */
    columnSpace: {
      type: Number,
      default: 20
    },
    /**
     * 自定义列计算宽度方法
     */
    computeWidthFn: {
      type: Function,
      default: void 0
    }
  },
  methods: {
    /**
     * widthUnit:字符宽度系数，字符宽度系数和font-size大小有关系,依次对应小写字母、大写字母、数字、中文、,. 、%-、其他符号的宽度
     *  */
    computeStrLength(e, a = [8, 10, 9, 14, 5, 6, 14]) {
      if (this.computeWidthFn)
        return this.computeWidthFn(e);
      let t = 0;
      for (const i of e)
        i >= "a" && i <= "z" ? t += a[0] : i >= "A" && i <= "Z" ? t += a[1] : i >= "0" && i <= "9" ? t += a[2] : i >= "一" && i <= "龥" ? t += a[3] : i === "," || i === "." || i === " " ? t += a[4] : i === "%" || i === "-" ? t += a[5] : t += a[6];
      return Math.ceil(t);
    }
  },
  computed: {
    computedWidth() {
      var e, a, t, i;
      if (this.minWidth)
        return /%$/.test(this.minWidth) ? this.minWidth : parseFloat(this.minWidth) + 2;
      if (this.width === "computed") {
        let o = 0, r = !1, h = 0, n = 0, s = 0;
        if (!this.data || !((e = this.data) != null && e.length) || ((a = this.data) == null ? void 0 : a.length) === 0 || this.data === void 0)
          r = !0, s = this.label ? this.computeStrLength(this.label) : 100, (t = this.$attrs) != null && t.sortable && (s = s + 18);
        else {
          const u = this.data[0][this.prop + "Slot"] ? this.prop + "Slot" : this.prop;
          for (let l = 0; l < this.data.length; l++) {
            if (this.data[l][u] === null)
              return;
            const y = this.data[l][u] + "", c = this.data[h][u] + "";
            y.length > c.length && (h = l);
          }
          n = this.computeStrLength(
            this.data[h][u] + ""
          ), this.label && (s = this.computeStrLength(this.label), (i = this.$attrs) != null && i.sortable && (s = s + 18)), n = n > s ? n : s;
        }
        return o = r ? s : n, o > this.maxWidth && (o = this.maxWidth), o += 2 * this.columnSpace + 2, o + "px";
      } else
        return this.width;
    }
  }
};
function K(e, a, t, i, o, r) {
  const h = T("TableColumn", !0);
  return d(), M(h, f(m(m({}, e.$attrs), e.$props), {
    width: this.width === "computed" ? "auto" : this.width,
    "min-width": r.computedWidth,
    align: t.align,
    label: t.label,
    "show-overflow-tooltip": t.showOverflowTooltip
  }), {
    header: p((n) => [
      W(e.$slots, "header", _(E(n)))
    ]),
    default: p((n) => [
      W(e.$slots, "default", _(E(n)))
    ]),
    _: 3
    /* FORWARDED */
  }, 16, ["width", "min-width", "align", "label", "show-overflow-tooltip"]);
}
const z = /* @__PURE__ */ B(J, [["render", K], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/table/table-column.vue"]]), Q = {
  props: {
    /**
     * 表格列数据
     */
    columns: {
      type: Array,
      default: () => []
    },
    /**
     * 表格数据
     */
    data: {
      type: Array,
      default: () => []
    },
    /**
     * 控制分页的展示和隐藏
     */
    pagination: {
      type: Boolean,
      default: !1
    },
    /**
     * 控制分页的页码展示
     */
    paginationConfig: {
      type: Object,
      default: () => ({})
    },
    /**
     * table的高度，默认为auto，同element的height属性，默认为自动高度。
     * 如果 height 为 number 类型，单位 px；如果 height 为 string 类型，
     * 则这个高度会设置为 Table 的 style.height 的值，Table 的高度会受控于外部样式。
     */
    height: {
      type: [String, Number],
      default: "auto"
    },
    /**
     * 行样式
     */
    rowStyle: {
      type: [Function, Object]
    },
    /**
     * 总条目数，展示分页时必传，采用无限滚动时，也需要传该值
     */
    total: {
      type: Number,
      default: 0
    },
    /**
     * 每页显示个数选择器的选项设置
     */
    pageSize: {
      type: Number,
      default: 10
    },
    /**
     * 当前页数，支持 .sync 修饰符
     */
    currentPage: {
      type: Number,
      default: 1
    },
    /**
     * 空数据时的文案
     */
    emptyText: {
      type: String
    },
    /**
     * 所有列的min-width配置
     */
    colMaxWidth: {
      type: Number,
      default: 0
    },
    /**
     * 分页方式，支持两种展示方式：1.default-展示切换箭头和页码，适用于知道total的情况，2.arrow-只展示左右切换箭头 3.scroll-滚动加载更多的情况
     */
    paginationType: {
      type: String,
      default: "default"
    },
    /**
     * 控制表格列是否吸顶,根据UI设计，默认top为80
     */
    sticky: {
      type: Boolean,
      default: !1
    },
    /**
     * 吸顶时候设置的top值
     */
    stickyTop: {
      type: Number,
      default: 0
    },
    /**
     * 滚动加载图标，适用于无限滚动加载的场景，会在加载到底部的时候显示一个加载图标，注意！！！：只建议在无固定列的表格中使用，在有固定列的时候滚动底部的时候，固定列会出现偏差
     */
    scrollLoading: {
      type: Boolean,
      default: !1
    },
    /**
     * 列与列之间的内间距,只支持数字，单位为像素,只提供给列宽的动态计算使用，不建议使用，如果使用，需要样式覆盖列内边距
     */
    columnSpace: {
      type: Number,
      default: 20
    }
  },
  emits: [
    {
      /**
       * mfa校验通过，回传mfaToken
       */
      currentPageChange: (e) => null,
      handleSizeChange: (e) => null
    },
    "update:currentPage",
    "current-page-change",
    "update:pageSize",
    "current-size-change",
    "load-more"
  ],
  name: "rTable",
  // directives: {
  //   // 滚动加载更多指令，提供disabled参数，该参数和infinite-scroll-disabled属性的区别在于直接不会绑定滚动监听事件，同时也不会设定默认的height，兼容性处理
  //   loadMore: {
  //     mounted(el, binding, VNode, oldVNode) {
  //       if (binding.arg === 'disabled') return
  //       const scrollElem = el.querySelector(elTableScrollWrapperClass)
  //       if (!scrollElem) {
  //         throw new Error(
  //           `${msgTitle}${elTableScrollWrapperClass} element not found.`
  //         )
  //       }
  //       scrollElem.style.overflowY = 'auto'
  //       // after render
  //       setTimeout(() => {
  //         // 滚动加载需要有一个高度,这个高度支持可配
  //         if (!el.style.height) {
  //           scrollElem.style.height = binding.arg
  //           // eslint-disable-next-line
  //           console.warn(
  //             `${msgTitle} r-table height required, otherwise will set default value: 65vh`
  //           )
  //         }
  //         syncOptions(el, scrollElem)
  //         // use `InfiniteScroll`
  //         // InfiniteScroll.inserted(scrollElem, binding, VNode, oldVNode)
  //       }, 0)
  //     },
  //     updated(el, binding) {
  //       if (binding.arg === 'disabled') return
  //       syncOptions(el, el.querySelector(elTableScrollWrapperClass))
  //     },
  //     unMounted(el, binding, VNode, oldVNode) {
  //       if (binding.arg === 'disabled') return
  //       const scrollElem = el.querySelector(elTableScrollWrapperClass)
  //       InfiniteScroll.unbind(scrollElem)
  //     },
  //   },
  // },
  components: {
    Table: j,
    Pagination: G,
    RTableColumn: z,
    Loading: I
  },
  data() {
    return {
      tableColumnProps: [],
      layout: null,
      // 右侧fixed的表格
      rightFixedWrapper: null,
      // 左侧fixed的表格
      fixedWrapper: null
    };
  },
  computed: {
    currentEmptyText() {
      return this.emptyText || this.$t("bmui-table.noData");
    },
    // 总数并且data都不为空
    isEmpty() {
      var e;
      return this.total > 0 && ((e = this.data) == null ? void 0 : e.length) > 0 ? "" : "is-empty";
    },
    showEmpty() {
      var e;
      return this.total === 0 && ((e = this.data) == null ? void 0 : e.length) === 0;
    },
    /**
     * paginationType 为scroll的时候，不展示数据
     */
    showPagination() {
      return this.pagination && this.total > 0 && this.paginationType !== "scroll";
    },
    isSticky() {
      return this.sticky ? "is-sticky" : "";
    },
    hasFixedColumn() {
      const e = /* @__PURE__ */ new Set();
      return this.columns.forEach((a) => {
        a != null && a.fixed && e.add(`${a.fixed}`);
      }), e;
    },
    // 数据全部加载完成时滚动处于禁止状态
    scrollDisabled() {
      var e;
      return this.paginationType !== "scroll" || ((e = this.data) == null ? void 0 : e.length) === this.total && this.total !== 0;
    },
    // 设置loadmore的参数
    loadMoreArg() {
      return this.paginationType !== "scroll" ? "disabled" : this.height;
    },
    attrs() {
      return this.height === "auto" ? m({}, this.$attrs) : C(m({}, this.$attrs), { height: this.height });
    }
  },
  watch: {
    stickyTop() {
      this.sticky && this.$nextTick(() => {
        this.setFixedTableSticky();
      });
    }
  },
  methods: {
    loadMore() {
      this.scrollDisabled || b(this, "load-more");
    },
    // header头的的slot名称
    propToHeader(e) {
      return e && "header" + e.slice(0, 1).toUpperCase() + e.slice(1);
    },
    currentPageChange(e) {
      b(this, "update:currentPage", e), b(this, "current-page-change", e);
    },
    handleSizeChange(e) {
      b(this, "update:pageSize", e), b(this, "current-size-change", e);
    },
    getMaxWidth(e) {
      const a = this.colMaxWidth ? this.colMaxWidth : 160;
      return e != null && e.maxWidth && e.maxWidth > a ? e.maxWidth : a;
    },
    getColumnSpace(e) {
      return e != null && e.columnSpace ? e == null ? void 0 : e.columnSpace : this.columnSpace;
    },
    setFixedTableSticky() {
      var n;
      const e = (n = this.$refs.rTableMain) == null ? void 0 : n.$refs, a = e == null ? void 0 : e.rightFixedWrapper, t = e == null ? void 0 : e.rightFixedTableHeader, i = e == null ? void 0 : e.rightFixedBodyWrapper, o = e == null ? void 0 : e.headerWrapper, r = e == null ? void 0 : e.fixedHeaderWrapper, h = e == null ? void 0 : e.rightFixedHeaderWrapper;
      o && (o.style.top = this.stickyTop + "px"), r && (r.style.top = this.stickyTop + "px"), h && (h.style.top = this.stickyTop + "px"), this.hasFixedColumn.has("right") && a && t && i && (t.$el.style.transform = `translateX(calc(-100% + ${a.style.width}))`, i.childNodes[0].style.transform = `translateX(calc(-100% + ${a.style.width}))`);
    }
  },
  mounted() {
    this.layout = this.$refs.rTableMain.layout, this.sticky && this.$nextTick(() => {
      this.setFixedTableSticky();
    }), this.$nextTick(() => {
      console.log("$scopedSlots", this);
    });
  }
}, Y = /* @__PURE__ */ x(
  "div",
  { style: { width: "100%", height: "490px" } },
  null,
  -1
  /* HOISTED */
), U = { class: "r-table-loading" }, R = {
  key: 0,
  class: "r-table-empty"
}, ee = ["src"], te = {
  key: 1,
  class: "r-table-pagination"
};
function ae(e, a, t, i, o, r) {
  const h = T("RTableColumn"), n = T("Loading"), s = T("Table", !0), u = T("Pagination");
  return d(), g(
    "div",
    {
      class: X(["r-table-wrap", r.isEmpty, r.isSticky])
    },
    [
      w(s, f(r.attrs, {
        data: t.data,
        ref: "rTableMain",
        class: "r-table",
        "header-row-class-name": "r-table-row",
        "header-cell-class-name": "r-table-cell",
        "row-class-name": "r-table-row",
        "cell-class-name": "r-table-cell",
        "row-style": t.rowStyle
      }), q({
        empty: p(() => [
          Y
        ]),
        default: p(() => [
          (d(!0), g(
            k,
            null,
            Z(t.columns, (l, y) => (d(), M(h, f(
              y === 0 || t.columns[0].type === "selection" && y === 1 ? C(m({}, l), { align: "left" }) : l,
              {
                key: y,
                data: t.data,
                columnSpace: r.getColumnSpace(l),
                maxWidth: r.getMaxWidth(l)
              }
            ), {
              header: p((c) => [
                e.$slots[r.propToHeader(l.prop)] ? W(e.$slots, r.propToHeader(l.prop), _(f({ key: 0 }, c))) : (d(), g(
                  k,
                  { key: 1 },
                  [
                    L(
                      F(l.label),
                      1
                      /* TEXT */
                    )
                  ],
                  64
                  /* STABLE_FRAGMENT */
                ))
              ]),
              default: p((c) => [
                e.$slots[l.prop] ? W(e.$slots, l.prop, _(f({ key: 0 }, c))) : (d(), g(
                  k,
                  { key: 1 },
                  [
                    L(
                      F(c.row[l.prop]),
                      1
                      /* TEXT */
                    )
                  ],
                  64
                  /* STABLE_FRAGMENT */
                ))
              ]),
              _: 2
              /* DYNAMIC */
            }, 1040, ["data", "columnSpace", "maxWidth"]))),
            128
            /* KEYED_FRAGMENT */
          ))
        ]),
        _: 2
        /* DYNAMIC */
      }, [
        t.scrollLoading ? {
          name: "append",
          fn: p(() => [
            x("div", U, [
              w(n)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["data", "row-style"]),
      S(" 空状态单独定位，避免列过多时空记录随横向滚动条滚动发生位移 "),
      r.showEmpty ? (d(), g("div", R, [
        x("img", {
          src: require("../assets/img/no-data.png")
        }, null, 8, ee),
        x(
          "span",
          null,
          F(r.currentEmptyText),
          1
          /* TEXT */
        )
      ])) : S("v-if", !0),
      S(" 自动集成分页功能，total为null时也不展示分页，保证重新渲染分页器 "),
      r.showPagination ? (d(), g("div", te, [
        w(u, f(t.paginationConfig, {
          "page-size": t.pageSize,
          "current-page": t.currentPage,
          total: t.total,
          onCurrentChange: r.currentPageChange,
          type: t.paginationType,
          onSizeChange: r.handleSizeChange
        }), null, 16, ["page-size", "current-page", "total", "onCurrentChange", "type", "onSizeChange"])
      ])) : S("v-if", !0)
    ],
    2
    /* CLASS */
  );
}
const P = /* @__PURE__ */ B(Q, [["render", ae], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/table/table.vue"]]);
P.install = function(e) {
  e.component(P.name, P), e.component(z.name, z);
};
export {
  P as default
};
